export const rateProducts_cn = {
  // orderDetail
  freight_detail: '费用明细',
  counter_offer: '还价',

  // AssessOfSingleRateDrawer
  customer_rates: '收费率',
  rated: '评价时间',
  mode: '商品类型',

  // 砍价成功 BargainSuccessDialog
  counter_sent_seller: '还价请求已发送给卖家',
  seller_check_later_1: '卖家会尽快审核您的还价请求，请检查您的邮箱或者在您的',
  seller_check_later_2: '预订单列表',
  seller_check_later_3: '查看结果更新',
  back: '返回',
  view_order_list: '查看预订单列表',
  complete_booking: '完善订舱信息',

  // 费用明细 FreightDetail
  no_response_will_cancel:
    '如果卖家在3天之后仍未响应您的还价请求，该请求将被自动取消。请注意，如果卖家接受了您的还价请求之后您选择取消订单，将会产生USD200每集装箱的罚金',
  charge_name: '费用名称',
  comment: '计费单位',
  chargeable_weight: '计费重量',
  unit: '数量',
  unit_price: '单位价格',
  currency: '币种',
  potential_charges: '潜在费用',
  amount: '金额',
  subtotal: '合计',
  total: '总计',
  price_spread: '差价合计',
  potential_apply_as_cancel: '潜在费用并不会显示在预先计算的总计金额中，但是会在诸如退关取消等情况发生时而需要收取',
  ocean_freight: '海运费',
  truck_freight: '陆运费',
  air_freight: '空运费',
  POL_charges: '起运港费用',
  POD_charges: '卸货港费用',
  addtional_charges: '附加费',

  // 下单成功 OrderSuccessDialog
  purchase_confirmed: '舱位购买成功',
  complete_detail: '您可以立即完善您的订舱信息或者查看预订单列表',

  // 订单详情 orderDetail
  booking_summary: '订舱详情',
  POL: '起运港',
  POD: '卸货港',
  carrier: '船公司',
  air_carrier: '航空公司',
  trade_lane: '航线',
  ETD: '预计开航',
  service_code: '航线代码',
  transit_time: '航程',
  days: '天',
  container_type: '箱型',
  direct_transit: '直达还是中转',
  quantity: '箱量',
  stock: '库存',
  sufficientInv: '库存充足',
  sufficientInvTxt: '库存已达上限，无法继续添加',
  weight: '重量',
  volume: '体积',
  payload: 'KGS/柜',
  booking_cut_off: '截提单时间',
  proportion_of_cargo: '重泡比',
  cy_cut_off: '截关时间',
  valid_date: '生效日',
  expiring_date: '失效日期',
  remark: '备注',
  guaranteed_prepayment_1: '这是一个保证舱位的商品，您需要支付',
  guaranteed_prepayment_2: '的预付款来确认下单。请在',
  guaranteed_prepayment_3: '之前完成预付款操作，否则该订单将被自动取消',
  rate_valid_1: '此费率有效期至',
  rate_valid_2: '。如果您的货物在此日期后进港，或者您的集装箱超过了允许的标准重量，则价格可能会根据市场价格进行调整。',
  confirm_commodity:
    '我确认这是一批合法有效的商业货物并且货物均不在JCTRANS的禁止装运物品清单上。我确认搜索中输入的所有详细信息都是正确的。我接受报价的条款和所有关于装运的JCTRANS政策，包括主服务协议、买方条款和条件以及隐私政策。',
  confirm_and_book: '确认并订舱',
  pay_through_bank: '通过银行转账完成付款',
  account: '账号',
  bank_name: '开户行',
  bank_addr: '银行地址',
  swift_code: '银行代码',
  beneficiary: '受益人',
  upload_voucher: '付款后请上传转账水单凭证',
  shipments_upload_voucher_1: '付款完成后，请在',
  shipments_upload_voucher_2: '我的订单列表',
  shipments_upload_voucher_3: '上传转账凭证',
  pleaseNoteChange: '请留意保证金金额变化',

  // RateSinglePlane
  guaranteed_space: '舱位保证',
  years_member: '{0}年会员',
  isMyCompany: '不可下单自己公司的商品',
};
export const rateProducts_en = {
  // orderDetail
  freight_detail: 'Freight Detail',
  counter_offer: 'Counter offer',

  // AssessOfSingleRateDrawer
  customer_rates: 'Customer Rates',
  rated: 'Rated',
  mode: 'Mode',

  // 砍价成功 BargainSuccessDialog
  counter_sent_seller: 'Counter-offer has been sent to the seller',
  seller_check_later_1:
    'The seller will review your counter-offer as soon as possible. Please check your email or go to',
  seller_check_later_2: 'order list',
  seller_check_later_3: 'to find the result later.',
  back: 'Back',
  view_order_list: 'View order list',
  complete_booking: 'Complete booking',

  // 费用明细 FreightDetail
  no_response_will_cancel:
    "The counteroffer will be systematically cancelled if the seller doesn't response in 3 days. Please be aware, there will be a penalty of USD200/Container in case you cancel the booking after the seller agrees your counte roffer",
  charge_name: 'Charge name',
  comment: 'Comment',
  chargeable_weight: 'Chargeable Weight',
  unit: 'Unit',
  unit_price: 'Unit price',
  currency: 'Currency',
  potential_charges: 'Potential Charges',
  amount: 'Amount',
  subtotal: 'Subtotal',
  total: 'Total',
  price_spread: 'Price spread',
  potential_apply_as_cancel:
    'Potential charges would not be calculated in advance but would apply for exception such as cancellation.',
  ocean_freight: 'Ocean Freight',
  truck_freight: 'Truck Freight',
  air_freight: 'Air Freight',
  POL_charges: 'POL Charges',
  POD_charges: 'POD Charges',
  addtional_charges: 'Addtional Charges',

  // 下单成功 OrderSuccessDialog
  purchase_confirmed: 'Space purchase confirmed',
  complete_detail: 'You can either complete the booking detail now or view your order list.',

  // 订单详情 orderDetail
  booking_summary: 'Booking Summary',
  POL: 'POL',
  POD: 'POD',
  carrier: 'Carrier',
  air_carrier: 'Carrier',
  trade_lane: 'Trade Lane',
  ETD: 'ETD',
  service_code: 'Service Code',
  transit_time: 'Transit Time',
  days: 'Days',
  container_type: 'Container Type',
  direct_transit: 'Direct/Transit',
  quantity: 'Quantity',
  stock: 'Stock',
  sufficientInv: 'sufficient inventory',
  sufficientInvTxt: 'The inventory of goods has reached its limit and cannot be added further',
  weight: 'Weight',
  volume: 'Volume',
  payload: 'Payload',
  booking_cut_off: 'Booking Cut Off',
  proportion_of_cargo: 'The Proportion Of Cargo',
  cy_cut_off: 'CY Cut Off',
  valid_date: 'Valid Date',
  expiring_date: 'Expiring Date',
  remark: 'Remark',
  guaranteed_prepayment_1: 'This is a guaranteed space and prepayment of ',
  guaranteed_prepayment_2: ' is required，The space has been protected for you, please make the prepayment by ',
  guaranteed_prepayment_3: ", failure of which will be taken as cancellation and the space won't be protected then.",
  rate_valid_1: 'This rate is valid until ',
  rate_valid_2:
    '. If your goods are gated in after this date, or if your container exceeds the standard weight permitted, the rate may be subject to an adjustment in line with the marketplace rate.',
  confirm_commodity:
    'I confirm that this is a commercial shipment and that the commodity being shipped is not on JCTRANS’s list of items that cannot be shipped. I confirm that all details entered in the search are correct to the best of my knowledge. I accept the terms of the Quote and all JCTRANS policies regarding Shipments, including the Master Services Agreement, Terms and Conditions for Buyers and Privacy Policy.',
  confirm_and_book: 'Confirm and book',
  pay_through_bank: 'Complete payment through bank transfer',
  account: 'Account',
  bank_name: 'Bank Name',
  bank_addr: 'Bank Addr.',
  swift_code: 'Swift Code',
  beneficiary: 'Beneficiary',
  upload_voucher: 'Please upload transfer voucher after payment done',
  shipments_upload_voucher_1: 'Please go to ',
  shipments_upload_voucher_2: 'My shipments',
  shipments_upload_voucher_3: ' to upload transfer voucher once payment done',
  pleaseNoteChange: 'Please note the change of the margin amount',

  // RateSinglePlane
  guaranteed_space: 'Guaranteed Space',
  years_member: '{0} Years Member',
  isMyCompany: `Do not support placing orders for your own company's products`,
};
